// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promotion-card {
  width: 300px;
  height: 100%;
  display: flex;
  flex-flow: column;
  margin: auto;
  border-style: solid;
  border-width: 2px 2px 2px 2px;
  border-color: var(--ion-color-secondary-tint);
  border-radius: 10px;
  background-color: var(--ion-color-light);
  color: var(--ion-color-dark);
  position: relative;
}
.promotion-card app-promotion-action-buttons {
  flex: 1 1 auto;
}
@media (max-width: 729px) {
  .promotion-card {
    width: auto;
    max-width: 300px;
  }
}
@media (max-width: 550px) {
  .promotion-card {
    width: 100%;
  }
}
.promotion-card .no-image-div {
  width: 285px;
  height: 150px;
  position: relative;
}
.promotion-card .no-image-div .text-content {
  color: var(--ion-color-dark);
  position: absolute;
  left: 39%;
  top: 43%;
}
.promotion-card ::ng-deep.deposit-button ::ng-deep ion-button {
  width: 100%;
}
.promotion-card .card-content {
  min-height: 70px;
  padding-bottom: 0px;
}
.promotion-card .promo-status {
  position: absolute;
  height: 18px;
  width: 80px;
  border-bottom-right-radius: 15px;
  text-align: center;
  padding: 3px;
  font-size: 11px;
}
.promotion-card .promo-status-active {
  background-color: rgb(190, 114, 13);
}`, "",{"version":3,"sources":["webpack://./src/app/components/promotions/promotion-card/promotion-card.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EAWA,mBAAA;EACA,6BAAA;EACA,6CAAA;EACA,mBAAA;EACA,wCAAA;EACA,4BAAA;EACA,kBAAA;AATF;AAPE;EACE,cAAA;AASJ;AAPE;EATF;IAUI,WAAA;IACA,gBAAA;EAUF;AACF;AATE;EAbF;IAcI,WAAA;EAYF;AACF;AAJE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAMJ;AALI;EACE,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAON;AAHI;EACE,WAAA;AAKN;AAFE;EACE,gBAAA;EACA,mBAAA;AAIJ;AAFE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAIJ;AADE;EACE,mCAAA;AAGJ","sourcesContent":[".promotion-card {\r\n  width: 300px;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-flow: column;\r\n  margin: auto;\r\n  app-promotion-action-buttons {\r\n    flex: 1 1 auto;\r\n  }\r\n  @media (max-width: 729px) {\r\n    width: auto;\r\n    max-width: 300px;\r\n  }\r\n  @media (max-width: 550px) {\r\n    width: 100%;\r\n  }\r\n  border-style: solid;\r\n  border-width: 2px 2px 2px 2px;\r\n  border-color: var(--ion-color-secondary-tint);\r\n  border-radius: 10px;\r\n  background-color: var(--ion-color-light);\r\n  color: var(--ion-color-dark);\r\n  position: relative;\r\n  .no-image-div {\r\n    width: 285px;\r\n    height: 150px;\r\n    position: relative;\r\n    .text-content {\r\n      color: var(--ion-color-dark);\r\n      position: absolute;\r\n      left: 39%;\r\n      top: 43%;\r\n    }\r\n  }\r\n  ::ng-deep.deposit-button {\r\n    ::ng-deep ion-button {\r\n      width: 100%;\r\n    }\r\n  }\r\n  .card-content {\r\n    min-height: 70px;\r\n    padding-bottom: 0px;\r\n  }\r\n  .promo-status {\r\n    position: absolute;\r\n    height: 18px;\r\n    width: 80px;\r\n    border-bottom-right-radius: 15px;\r\n    text-align: center;\r\n    padding: 3px;\r\n    font-size: 11px;\r\n  }\r\n  // promo-status-<use status name here> to show different status background colors\r\n  .promo-status-active {\r\n    background-color: rgb(190, 114, 13);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
